export default "__VITE_PUBLIC_ASSET__8aa56775__"